// extracted by mini-css-extract-plugin
module.exports = {"slideshow-container":"slideshow-container__slideshow-container___Ge00h","slide-container":"slideshow-container__slide-container___n1zHn"};